<div>
  @if (sceneDetailsLoadComplete) {
    <div class="container">
      <img class="backArrow" src="assets/img/ic_back.svg" (click)="navigateBack()">

      <span class="title-styling">
        {{sceneDetailsResponse?.sceneName | splitCamelCaseTitle}}
      </span>

      <div class="border-style mt-4" style="padding: 10px;">

        <div class="row" style="padding: 15px;">
          <div class="col-12">
            <div>
              <img width="32px" [src]="getSceneIconSrc()">

              <span class="title-styling">
                {{sceneDetailsResponse?.sceneName | splitCamelCaseTitle}}
              </span>
            </div>
          </div>
        </div>

        <div class="row" style="margin-left: 5px; margin-bottom:10px;">

          <div class="col-3 scene-details">

            <div class="scene-details">
              <div class="scene-name">
                <div style="margin-bottom: 10px;">
                  {{'lang.scene_status' | translate }}
                </div>
                <div class="scene-style">
                  <span class="scene-sub-title">
                    {{'lang.scene_status' | translate }}
                  </span> <br>

                  <span>
                    <span class="scene-sub-title-value">
                      {{ getSceneState() | splitCamelCaseTitle}}
                    </span>
                  </span>
                </div>
                <br>

                <div class="scene-style">
                  <span class="scene-sub-title">
                    {{'lang.activation_reason' | translate}}
                  </span> <br>
                  <span class="scene-sub-title-value"> {{getSceneActivationReason()}} </span>
                </div>
              </div>
            </div>

            <div class="scene-details">
              <div class="scene-name">
                <div style="margin-bottom: 10px;">
                  {{'lang.site_details' | translate }}
                </div>
                <div class="scene-style">
                  <span class="scene-sub-title">{{'lang.site_name' | translate }}</span> <br>
                  <span class="scene-sub-title-value">
                    <a class="scene-details-value" [title]="sceneDetailsResponse?.siteDetails?.site_name" [routerLink]="['/sites/detail/', sceneDetailsResponse?.siteDetails?.site_id]">
                      {{ sceneDetailsResponse?.siteDetails?.site_name | slice:0:30 }}{{ sceneDetailsResponse?.siteDetails?.site_name?.length > 30 ? '...' : '' }}
                    </a>
                  </span>
                </div>
                <br>
              </div>
            </div>
          </div>

          <div class="col-9">
            <div>
              <tabset class="m-0">
                <tab class="siteusers" heading="{{'lang.features' | translate}}" (selectTab)="onSelect($event)">
                  <div class="siteuser">
                    <app-scene-profile-features
                      [sceneFeaturesList]="sceneDetailsResponse?.features"
                      [sceneStatus]="sceneDetailsResponse?.sceneStatus"
                      [activationReason]="sceneDetailsResponse?.activationReason"
                      [siteDetails]="sceneDetailsResponse?.siteDetails">
                    </app-scene-profile-features>
                  </div>
                </tab>
              </tabset>
            </div>
          </div>

        </div>

      </div>
    </div>
  }
</div>